import { render, staticRenderFns } from "./GiftIcon.vue?vue&type=template&id=b601c544&"
import script from "./GiftIcon.vue?vue&type=script&lang=js&"
export * from "./GiftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports